<template>
	<div class="w-100">
		<h3 class="mb-3" v-once>Indikator</h3>
		<span v-once
			>Silahkan memilih minimal satu Indikator yang tersedia di bawah</span
		>
		<div v-show="originalIsDatasetNextClicked">
			<b-skeleton-wrapper :loading="loadingIndicatorInput">
				<b-row class="mt-2 mx-0" align-v="center">
					<b-col class="p-0" cols="3">
						<b-skeleton type="input"></b-skeleton>
					</b-col>
				</b-row>
				<b-row v-for="val in 2" :key="val" class="mt-2 mx-0" align-v="center">
					<b-col class="p-0" cols="3">
						<b-skeleton type="input"></b-skeleton>
					</b-col>
					<b-col
						class="p-0"
						cols="1"
						style="display: flex !important; justify-content: center !important"
					>
						<b-skeleton type="button"></b-skeleton>
					</b-col>
				</b-row>
				<b-row class="mt-2 mx-0" align-v="center">
					<b-col class="p-0" cols="2"> </b-col>
					<b-col
						class="p-0"
						cols="1"
						v-for="val in 2"
						:key="val"
						style="display: flex !important; justify-content: center !important"
					>
						<b-skeleton type="button"></b-skeleton>
					</b-col>
				</b-row>
			</b-skeleton-wrapper>
		</div>

		<b-form
			class="form-group-tabel-dinamis mt-2 py-0"
			v-show="loadingIndicatorInput"
			inline
		>
			<div
				class="mt-2"
				v-show="optionsIndicator.length < 1"
				style="font-style: italic"
			>
				---Mohon maaf sebelumnya, indikator yang diinginkan belum tersedia untuk
				saat ini---
			</div>

			<b-row class="w-75">
				<b-col cols="12">
					<b-row>
						<b-col>
							<b-form-checkbox
								class="td-checkbox"
								:indeterminate="indeterminateIndicator"
								v-model="allIndicatorSelected"
								v-show="optionsIndicator.length > 0"
								@change="toggleAllIndicator"
								:disabled="isLoadingAnOptions"
							>
								{{ allIndicatorSelected ? "Unselect All" : "Select All" }}
							</b-form-checkbox>

							<b-form-checkbox-group
								v-model="selectedIndicator"
								stacked
								v-show="optionsIndicator.length > 0"
								class="ml-4"
								:disabled="isLoadingAnOptions"
							>
								<b-form-checkbox
									class="td-checkbox"
									v-for="option_indicator in optionsIndicator"
									:value="option_indicator"
									:key="option_indicator.id"
								>
									{{ option_indicator.name }}

									<b-button
										class="ml-2 td-btn-teal py-1 px-2 td-button-rounded-pill"
										:id="'indicator-metadata-popover-' + option_indicator.id"
										v-show="optionsIndicator.length > 0"
										size="sm"
									>
										<b-icon icon="tags" />
										Metadata</b-button
									>
									<b-popover
										:target="
											'indicator-metadata-popover-' + option_indicator.id
										"
										triggers="click blur"
									>
										<div class="td-popover-selection">
											<div>
												<b-row>
													<b-col>
														<h6 class="m-0">Metadata Indikator</h6>
													</b-col>
												</b-row>
											</div>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="bookmarks-fill" />
													<span class="font-weight-bold ml-1">Indikator</span>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span
														class="font-weight-bolder"
														style="font-size: 0.75rem"
														>{{ changeNullIntoStrip(option_indicator.name) }}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="chat-right-quote-fill" />
													<span class="font-weight-bold ml-1">Definisi</span>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(option_indicator.definition)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="gear-wide-connected" />
													<span class="font-weight-bold ml-1"
														>Mekanisme Perhitungan</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.calculationMechanism
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="calculator-fill" />
													<span class="font-weight-bold ml-1">Rumus</span>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span
														v-if="
															changeNullIntoStrip(option_indicator.formula) ===
															'-'
														"
														style="font-size: 0.75rem"
														>{{ changeNullIntoStrip(option_indicator.formula) }}
													</span>
													<katex-element
														v-else
														output="html"
														:displayMode="true"
														:expression="option_indicator.formula"
													/>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="shield-check" />
													<span class="font-weight-bold ml-1">Manfaat</span>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{ changeNullIntoStrip(option_indicator.benefit) }}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="layers-half" />
													<span class="font-weight-bold ml-1"
														>Interpretasi</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.interpretation
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="info-circle" />
													<span class="font-weight-bold ml-1">Satuan</span>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.measurementUnit
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="puzzle-fill" />
													<span class="font-weight-bold ml-1"
														>Disaggregasi</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.disaggregation
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="question-circle" />
													<span class="font-weight-bold ml-1"
														>Indikator Standar</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(option_indicator.standard)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="calendar2-week" />
													<span class="font-weight-bold ml-1"
														>Frekuensi Update</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.updateFrequency
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="map-fill" />
													<span class="font-weight-bold ml-1"
														>Level Penyajian</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.presentationLevel
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="building" />
													<span class="font-weight-bold ml-1"
														>Organisasi Penanggung Jawab</span
													>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(
																option_indicator.responsibleOrganization
															)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="dice5-fill" />
													<span class="font-weight-bold ml-1">Ukuran</span>
												</b-col>
											</b-row>

											<b-row>
												<b-col class="ml-4" cols="10">
													<span style="font-size: 0.75rem"
														>{{
															changeNullIntoStrip(option_indicator.measurement)
														}}
													</span>
												</b-col>
											</b-row>

											<b-row class="mt-2">
												<b-col>
													<b-icon icon="box" />
													<span class="font-weight-bold ml-1">Konsep</span>
												</b-col>
											</b-row>
											<ul style="list-style-type: circle">
												<li
													v-for="(concept, idx) in option_indicator.conceptList"
													:key="idx"
												>
													{{ concept.concept }}
												</li>
											</ul>
										</div>
									</b-popover>
								</b-form-checkbox>
							</b-form-checkbox-group>
						</b-col>
					</b-row>

					<b-row>
						<b-col
							class="mt-2 font-weight-bolder"
							style="font-size: 0.8rem !important"
						>
							Jumlah Indikator Terpilih: {{ selectedIndicator.length }}
						</b-col>
					</b-row>

					<b-row class="mt-2 text-right">
						<b-col>
							<b-button
								class="mx-1 td-btn-blue"
								v-show="optionsIndicator.length > 0"
								@click="nextRegularToDataset()"
								title="Melanjutkan ke opsi dataset"
								><b-icon icon="chevron-double-left" /> Kembali</b-button
							>

							<b-button
								class="mx-1 td-btn-blue"
								:disabled="
									selectedIndicator == null ||
									selectedIndicator.length < 1 ||
									isLoadingAnOptions
								"
								v-show="optionsIndicator.length > 0"
								@click="nextToPeriod()"
								title="Melanjutkan ke opsi periode"
								>Lanjut <b-icon icon="chevron-double-right"
							/></b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-form>
	</div>
</template>

<!-- javascript section-->
<script>
//import js modules section
import services from "../../../../../services/TabelDinamisServicesV3";
import utils from "../../../../../utils/TabelDinamisUtils.js";
import store from "../../../../../store/TabelDinamisStoreV3.js";
import "katex/dist/katex.min.css";

//local registration for output component
export default {
	name: "IndicatorSelection",
	data() {
		return {
			isIndicatorNextClicked: false,
			optionsIndicator: "",
			selectedIndicator: [],
		};
	},
	props: [
		"originalOptionsIndicator",
		"originalSelectedIndicator",
		"originalIsIndicatorNextClicked",
		"originalIsDatasetNextClicked",
		"datasetName",
		"datasetId",
		"isLoadingAnOptions",
		"isEditSelectedData",
		"idxSelectedData",
		"hasFinishedLoadEditedSelectedData",
	],
	created() {},
	destroyed() {},
	mounted: function () {},
	computed: {
		loadingIndicatorInput: function () {
			if (this.optionsIndicator === "") {
				return false;
			} else {
				return true;
			}
		},
		allIndicatorSelected: {
			get: function () {
				if (this.selectedIndicator.length === this.optionsIndicator.length) {
					return true;
				} else {
					return false;
				}
			},
			set: function () {},
		},
		indeterminateIndicator: function () {
			if (
				this.selectedIndicator.length > 0 &&
				this.selectedIndicator.length < this.optionsIndicator.length
			) {
				return true;
			} else {
				return false;
			}
		},
	},
	watch: {
		selectedIndicator: {
			handler: function (val) {
				if (
					!this.isEditSelectedData ||
					(this.isEditSelectedData && this.hasFinishedLoadEditedSelectedData)
				) {
					this.isIndicatorNextClicked = false;
				}

				this.$emit("update:originalSelectedIndicator", val);
			},
			immediate: true,
		},
		optionsIndicator: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.$emit("update:originalOptionsIndicator", newVal);
				}
			},
			immediate: true,
		},
		originalIsDatasetNextClicked: function (val) {
			if (val) {
				this.$emit("update:isLoadingAnOptions", true);

				let statusIndicatorOptionsLocalStorage =
					store.precheckIndicatorOptionsLocalStorage(this.datasetId);

				switch (statusIndicatorOptionsLocalStorage) {
					case "expired":
					case "not-set":
						this.loadIndicatorByDataset(this.datasetName);
						break;
					case "alive":
						setTimeout(
							function () {
								this.optionsIndicator = JSON.parse(
									store.getSelectionLocalStorageByKey("indicator")
								).find((item) => item.datasetId === this.datasetId).items;

								if (this.isEditSelectedData) {
									let selectedDataList =
										store.getSelectedDataListLocalStorageByCurrentUsername();

									this.selectedIndicator =
										selectedDataList[0].items[
											this.idxSelectedData
										].selectedIndicator;

									this.nextToPeriod();
								}

								this.$emit("update:isLoadingAnOptions", false);
							}.bind(this),
							200
						);

						break;
				}
			} else {
				this.optionsIndicator = "";
				this.selectedIndicator = [];
				this.isIndicatorNextClicked = false;
			}
		},
		isIndicatorNextClicked: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.$emit(
						"update:originalIsIndicatorNextClicked",
						this.isIndicatorNextClicked
					);
				}
			},
			immediate: true,
		},
		originalSelectedIndicator: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.selectedIndicator = newVal;
				}
			},
			immediate: true,
		},
		originalOptionsIndicator: {
			handler: function (newVal, oldVal) {
				if (newVal !== oldVal) {
					this.optionsIndicator = newVal;
				}
			},
		},
	},
	methods: {
		async loadIndicatorByDataset(val) {
			await services.getIndicatorByDatasetName(val).then(
				(response) => {
					this.optionsIndicator = response.data.data.indicatorList;
					utils.sortArrayByStringProperty(this.optionsIndicator, "name");

					store.updateSelectionLocalStorage(
						"indicator",
						this.optionsIndicator,
						{
							datasetName: this.datasetName,
							datasetId: this.datasetId,
						}
					);

					if (this.isEditSelectedData) {
						setTimeout(
							function () {
								let selectedDataList =
									store.getSelectedDataListLocalStorageByCurrentUsername();

								this.selectedIndicator =
									selectedDataList[0].items[
										this.idxSelectedData
									].selectedIndicator;

								this.nextToPeriod();
							}.bind(this),
							200
						);
					}

					this.$emit("update:isLoadingAnOptions", false);
				},
				(error) => {
					if (error.response.data.errors[0].code === "td-err.indicator.001") {
						this.optionsIndicator = [];
					}


					this.$emit("update:isLoadingAnOptions", false);
				}
			);
		},
		toggleAllIndicator(val) {
			this.selectedIndicator = val ? this.optionsIndicator : [];
		},
		nextToPeriod() {
			if (this.selectedIndicator.length > 0) {
				utils.scrollIntoDiv("tabel-dinamis-progress-stepper-period");
				this.isIndicatorNextClicked = true;
			}
		},
		nextRegularToDataset() {
			utils.scrollIntoDiv("tabel-dinamis-progress-stepper-dataset");
		},
		changeNullIntoStrip(val) {
			return utils.changeNullIntoStrip(val);
		},
	},
	components: {},
};
</script>

<!-- css section-->
<style lang="scss" scoped>
@import "src/assets/scss/_table-dinamis";
</style>

<!-- author: m.hanif.fahyuananto-->
<!-- version 3.0.0 -->
<!-- created on 25-04-2022 -->
